import ISubjects from '../@types/ISubjects';

// eslint-disable-next-line max-len
const getContentPagePath = (subjects: ISubjects[], slug: string, page: string, section?: string): string => {
  const subject = subjects.find((s) => s.slug === slug);
  const BASE_PATH = 'content/html';

  if (!subject) return '';

  if (page === 'inicio') {
    return `${BASE_PATH}/${subject.id}_${subject.slug}/0_inicio.html`;
  }

  if (subject.children) {
    const childPage = subject.children.find((child) => child.slug === page);

    if (childPage?.children) {
      if (childPage.slug === page && section === undefined) {
        return `${BASE_PATH}/${subject.id}_${subject.slug}/${childPage.id}_${childPage.slug}/0_inicio.html`;
      }

      return `${BASE_PATH}/${subject.id}_${subject.slug}/${childPage.id}_${childPage.slug}/${section}.html`;
    }

    if (childPage) {
      return `${BASE_PATH}/${subject.id}_${subject.slug}/${childPage.id}_${childPage.slug}.html`;
    }
  }

  return '';
};

export default getContentPagePath;
